import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux'
import './i18n'
import routes from './client/js/router/router_player'
import store from './client/js/store/store'

const app = document.getElementById('app');
ReactDOM.render(
	<Provider store={store}>
		<BrowserRouter>
			{routes}
		</BrowserRouter>
	</Provider>,
	app,
)
